import React from 'react';
import { Result, Button, Tooltip } from 'antd';
import assetITIcon from '../../assets/img/assetIT_icon.png';
import { getQueryParamFromUrl } from '../../utils';
import { useStyle } from './styles';
import { PLUGIN_ID } from '../../api/constant';

const MainLayout = () => {
  const classes = useStyle();
  const id = getQueryParamFromUrl(window.location.search, 'id');
  const tag = getQueryParamFromUrl(window.location.search, 'tag');
  const host = getQueryParamFromUrl(window.location.search, 'instance');

  const openJiraApp = () => {
    const jiraInstance = `https://${host}.atlassian.net`;
    const target = `${jiraInstance}/jira/apps/${PLUGIN_ID}/${
      process.env.REACT_APP_PLUGIN_ENV_ID
    }?itemId=${id}&scan=${true}`;

    window.open(target, '_blank');
  };

  return (
    <div className={classes.mainSection}>
      <Result
        icon={<img style={{ maxWidth: '80px', objectFit: 'contain' }} src={assetITIcon} alt="" />}
        title="Asset Info"
        subTitle={`ID: ${id}, Asset Tag: ${tag}`}
        extra={[
          <Button type="primary" key="console" className={classes.btnPrimary} target="_blank" onClick={openJiraApp}>
            View details
          </Button>,
          <Tooltip
            type="primary"
            className={classes.btnPrimary}
            key="contact"
            title="This feature is under construction"
            placement="top"
          >
            <Button disabled={true}>Contact Admin</Button>
          </Tooltip>,
        ]}
      />
    </div>
  );
};

export default MainLayout;
